import React, { FunctionComponent } from "react"; // importing FunctionComponent

type PageProps = {
  /** Layout of the page */
  pageClass?: string;
};
export const Page: FunctionComponent<PageProps> = ({ children, pageClass }) => {
  return <div className={`App layout__page ${pageClass ? pageClass : ""}`}>{children}</div>;
};
